module.exports = __webpack_public_path__ + "assets/img/Processing.f028f92f.svg";